import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/shared/service/app-config.service';
import { MatomoTracker } from 'ngx-matomo';
import { LayoutComponent} from'src/app/layout/layout.component';

@Component({
  selector: 'app-wmsm-RoleAccounts',
  templateUrl: './wmsm-RoleAccounts.component.html',
  styleUrls: ['./wmsm-RoleAccounts.component.css']
})
export class WmsmRoleAccountsComponent implements OnInit {

  constructor(
    private matomotracker:MatomoTracker,
    private ConfigService: AppConfigService,
    private LayoutComponent:LayoutComponent
  ) { }

  ngOnInit() {
    this.LayoutComponent.geturl()
    this.matomotracker.trackPageView("IDM")
    this.matomotracker.trackEvent("IDM","IDM Link","Transation",1);
  }
  GotoIDM(){
    window.open(this.ConfigService.getActualConfig('idmConfig.IDM_URL'),'_blank')
  }
}
